import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type Lightbulb2Props = IconComponentBaseProps;

export const Lightbulb2 = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: Lightbulb2Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_10823_77885"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10823_77885)">
        <path
          d="M8.33334 15C7.87501 15 7.48264 14.8368 7.15626 14.5104C6.82987 14.184 6.66667 13.7917 6.66667 13.3334V12.2917C5.87501 11.75 5.26042 11.0556 4.82292 10.2084C4.38542 9.36113 4.16667 8.45835 4.16667 7.50002C4.16667 5.87502 4.73264 4.49655 5.86459 3.3646C6.99653 2.23266 8.375 1.66669 10 1.66669C11.625 1.66669 13.0035 2.23266 14.1354 3.3646C15.2674 4.49655 15.8333 5.87502 15.8333 7.50002C15.8333 8.45835 15.6146 9.35766 15.1771 10.1979C14.7396 11.0382 14.125 11.7361 13.3333 12.2917V13.3334C13.3333 13.7917 13.1701 14.184 12.8438 14.5104C12.5174 14.8368 12.125 15 11.6667 15H8.33334ZM8.33334 13.3334H11.6667V11.4167L12.375 10.9167C12.9444 10.5278 13.3854 10.0313 13.6979 9.4271C14.0104 8.82294 14.1667 8.18058 14.1667 7.50002C14.1667 6.34724 13.7604 5.3646 12.9479 4.5521C12.1354 3.7396 11.1528 3.33335 10 3.33335C8.84723 3.33335 7.86459 3.7396 7.05209 4.5521C6.23959 5.3646 5.83334 6.34724 5.83334 7.50002C5.83334 8.18058 5.98959 8.82294 6.30209 9.4271C6.61459 10.0313 7.05556 10.5278 7.62501 10.9167L8.33334 11.4167V13.3334ZM8.33334 18.3334C8.09723 18.3334 7.89931 18.2535 7.73959 18.0938C7.57987 17.934 7.50001 17.7361 7.50001 17.5V16.6667H12.5V17.5C12.5 17.7361 12.4201 17.934 12.2604 18.0938C12.1007 18.2535 11.9028 18.3334 11.6667 18.3334H8.33334Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
